import { environment } from '../../../environments/environment';

export interface Theme {
  name: string;
  properties: any;
  //  config: any;
  //  environments: any;
}

export const all: Theme = {
  name: environment.themeConfig.brand,
  properties: {
    webElements: {
      favicon: environment.assetsUrl + 'assets/images/icon/favicon.ico',
      manifestJson: environment.assetsUrl + 'assets/images/icon/manifest.json',
      appleIcon57x57: environment.assetsUrl + 'assets/images/icon/apple-icon-57x57.png',
      appleIcon60x60: environment.assetsUrl + 'assets/images/icon/apple-icon-60x60.png',
      appleIcon72x72: environment.assetsUrl + 'assets/images/icon/apple-icon-72x72.png',
      appleIcon76x76: environment.assetsUrl + 'assets/images/icon/apple-icon-76x76.png',
      appleIcon114x114: environment.assetsUrl + 'assets/images/icon/apple-icon-114x114.png',
      appleIcon120x120: environment.assetsUrl + 'assets/images/icon/apple-icon-120x120.png',
      appleIcon144x144: environment.assetsUrl + 'assets/images/icon/apple-icon-144x144.png',
      appleIcon152x152: environment.assetsUrl + 'assets/images/icon/apple-icon-152x152.png',
      appleIcon180x180: environment.assetsUrl + 'assets/images/icon/apple-icon-180x180.png',
      androidIcon192x192: environment.assetsUrl + 'assets/images/icon/android-icon-192x192.png',
      favicon32x32: environment.assetsUrl + 'assets/images/icon/favicon-32x32.png',
      favicon96x96: environment.assetsUrl + 'assets/images/icon/favicon-96x96.png',
      favicon16x16: environment.assetsUrl + 'assets/images/icon/favicon-16x16.png',
      msIcon144x144: environment.assetsUrl + 'assets/images/icon/ms-icon-144x144.png',
    },
    logoNavUrl: environment.assetsUrl + 'assets/images/logo-2x.png',
    logoLoginUrl: environment.assetsUrl + 'assets/images/logo-login.png',
    logoLoginBlackUrl: environment.assetsUrl + 'assets/images/logo-login-black.png',
    backgroundUrl: environment.assetsUrl + 'assets/images/bg_23.jpg',
    logoSpalshScreenUrl: environment.assetsUrl + 'assets/images/logo-black-white.png',
    logoColorUrl: environment.assetsUrl + 'assets/images/logo-color.png',
    logoGrayUrl: environment.assetsUrl + 'assets/images/logo-gray-2x.png',
    miniLogoUrl: environment.assetsUrl + 'assets/images/mini-logo.jpg',
    appIconUrl: environment.assetsUrl + 'assets/images/app-icon-sm.png',
    mobileScreeAPP: environment.assetsUrl + 'assets/images/mobile_overlay_app.png',
    markerDefaultEquipmentUrl: environment.assetsUrl + 'assets/images/jd_trattori_grande.jpg',
    '--p-xFarm-xColor-400': environment.primary,
    '--p-xFarm-xColor-400-opacity': environment.primaryOpacity,
    '--p-xFarm-xColor-400-opacity-15': environment.primaryOpacity15,
    '--secondary': environment.secondary,
    '--text-color-nav': environment.textColorNav,
    '--text-color-header-table': environment.textColorHeaderTable,
    '--text-login-version': environment.textLoginVersion,
    '--btn-success': environment.btnSuccess,
    '--background-splash-screen': environment.backgroundSplashScreen,
    '--spinner-splash-screen': environment.spinnerSplashScreen,
    '--navbar-color': environment.navBarColor,
    '--text-btnsuccess': environment.textBtnSuccess,
    '--text-btnhover': environment.textBtnHover,
    '--color-sidebar-header': environment.colorSidebarHeader,
    '--text-color-sidebar': environment.textColorSidebar,
    ...environment.palette,
  },
};
